import styled from 'styled-components';

export const FormContainer = styled.div`
    padding: 1.5rem;
    background-color: #f9f9f9;
    border-radius: 8px;
`;